import React, { useEffect, useState } from 'react';
import ScheduleIcon from '@mui/icons-material/Schedule';
import { useDeliveryPrice } from '../../hooks/useDeliveryPrice';
import dayjs from '../../../../utils/dayjs';
import {
  AlertContainer,
  AlertMessageContainer,
  AlertSubHeading,
  AlertContentContainer,
} from '../alert';
import { typography } from '../../../../theme';
import { useOrder } from '../../../../state/order/hooks/useOrder';

export const DynamicPriceBanner: React.FC = () => {
  const [isDynamicBannerShown, setDynamicBannerShown] = useState(false);

  const { isDeliveryPriceChanged, currentDeliveryPrice, lastUpdatedAt } = useDeliveryPrice();
  const order = useOrder();

  useEffect(() => {
    if (isDeliveryPriceChanged) {
      queueMicrotask(() => {
        setDynamicBannerShown(true);
      });
    }
  }, [currentDeliveryPrice, isDeliveryPriceChanged]);

  // Close banner on restaurant change
  useEffect(() => {
    queueMicrotask(() => {
      setDynamicBannerShown(false);
    });
  }, [order.restaurantId]);

  return isDynamicBannerShown && typeof currentDeliveryPrice === 'number' && lastUpdatedAt ? (
    <AlertContainer>
      <AlertContentContainer>
        <ScheduleIcon style={{ fontSize: 32 }} />
        <AlertMessageContainer>
          <AlertSubHeading>
            <span>Dynaaminen kuljetushinta päivittyi</span>{' '}
            <typography.Text>
              <strong>
                {currentDeliveryPrice.toString().replace('.', ',')} euroon klo{' '}
                {dayjs(+lastUpdatedAt * 1000).format('HH.mm')}
              </strong>
            </typography.Text>
            <span>. Hinta tarkistetaan 10 min välein.</span>
          </AlertSubHeading>
        </AlertMessageContainer>
      </AlertContentContainer>
    </AlertContainer>
  ) : null;
};
